import React, { useState, useEffect } from 'react'
import axiosJWT from '../../JwtToken'

export const Perorangan = () => {
    const [pesan, setPesan] = useState(false)
    const [msg, setMsg] = useState("")

    const [nib, setNIB] = useState('')
    const [no_npwp, setNPWP] = useState('')
    const [nm_usaha, setNmUsaha] = useState('')
    const [no_kec, setNoKec] = useState('')
    const [no_kel, setNoKel] = useState('')
    const [no_rw, setNoRw] = useState('')
    const [no_rt, setNoRt] = useState('')
    const [alamat, setAlamat] = useState('')
    const [kd_pos, setKdPos] = useState('')
    const [kecamatan, setKecamatan] = useState([])
    const [kelurahan, setKelurahan] = useState([])

    useEffect(() => {
        getAkun()
        getKecamatan()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getKecamatan = async () => {
        try {
            const response = await axiosJWT.post(`/api/wilayah/kecamatan`, {
                no_prop: '32',
                no_kab: '75'
            })
            setKecamatan(response.data)
            setNoKec('')
        } catch {
            setKecamatan([])
            setNoKec("")
        }
    }

    const getKelurahan = async (key) => {
        try {
            const response = await axiosJWT.post(`/api/wilayah/kelurahan`, {
                no_prop: '32',
                no_kab: '75',
                no_kec: key
            })
            setKelurahan(response.data)
            setNoKel('')
            setNoKec(key)
        } catch {
            setKelurahan([])
            setNoKel("")
            setNoKec(key)
        }
    }

    const getAkun = async () => {
        const response = await axiosJWT.get(`/api/perorangan/publish`)
        const kecamatan = await axiosJWT.post(`/api/wilayah/kecamatan`, {
            no_prop: response.data.no_prop,
            no_kab: response.data.no_kab,
            no_kec: response.data.no_kec
        })
        setKecamatan(kecamatan.data)
        const kelurahan = await axiosJWT.post(`/api/wilayah/kelurahan`, {
            no_prop: response.data.no_prop,
            no_kab: response.data.no_kab,
            no_kec: response.data.no_kec,
            no_kel: response.data.no_kel
        })
        setKelurahan(kelurahan.data)
        // End KTP

        setNIB(response.data.nib)
        setNPWP(response.data.no_npwp)
        setNmUsaha(response.data.nm_usaha)
        setNoKec(response.data.no_kec)
        setNoKel(response.data.no_kel)
        setNoRw(response.data.no_rw)
        setNoRt(response.data.no_rt)
        setAlamat(response.data.alamat)
        setKdPos(response.data.kd_pos)
    }

    const getWaktuSekarang = () => {
        const d = new Date()
        const date = d.toISOString().split('T')[0] // Hasil: 2024-06-06
        const time = d.toTimeString().split(' ')[0] // Hasil: 09:59:42
        return `${date} ${time}`
    }

    const editAkun = async (e) => {
        e.preventDefault()

        try {
            const waktu = getWaktuSekarang()

            const response = await axiosJWT.put(`/api/perorangan/akun`, {
                nib, no_npwp, nm_usaha, no_kec, no_kel, no_rw, no_rt, alamat, kd_pos,
                u_date: waktu,
            })

            getPesan()
            setMsg(response.data.msg)
            setTimeout(() => {
                getPesan()
                setMsg('')
            }, 2000)

        } catch (err) {
            getPesan()
            // Pengaman build tanpa ?.
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                || 'Maaf, proses update gagal!'
            setMsg(errorMsg)
            setTimeout(() => {
                getPesan()
                setMsg('')
            }, 2000)
        }
    }

    const getPesan = () => {
        setPesan((prevState) => !prevState)
    }

    const display = {
        display: `${pesan ? "block" : "none"}`,
    }

    return (<>
        <div className="container">
            <div className="card animated fadeInUp animation-delay-7 br-2 mb-6">
                <div className="card-body p-5">
                    <form onSubmit={editAkun} className="form-horizontal">
                        <h5 className="right-line color-success">Data Pelaku Usaha</h5>
                        <div className="row">
                            <div className="form-group col-md-6">
                                <label className="control-label">NIB *</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-id-badge"></i></span>
                                    <input type="text" id="nib" className="form-control" value={nib} onChange={(e) => setNIB(e.target.value)} required/>
                                </div>
                                {/* <span className='badge d-inline-block text-wrap badge-danger'>Pergantian NIB melalui Admin</span> */}
                            </div>
                            <div className="form-group col-md-6">
                                <label className="control-label" htmlFor="no_npwp">No. NPWP *</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-id-badge"></i></span>
                                    <input type="text" id="no_npwp" className="form-control" value={no_npwp} onChange={(e) => setNPWP(e.target.value)} required/>
                                </div>
                                {/* <span className='badge d-inline-block text-wrap badge-danger'>Pergantian No. NPWP melalui Admin</span> */}
                            </div>
                            <div className="form-group col-md-12">
                                <label className="control-label">Nama Usaha *</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-id-badge"></i></span>
                                    <input type="text" id="nm_usaha" className="form-control" value={nm_usaha} onChange={(e) => setNmUsaha(e.target.value)} required/>
                                </div>
                            </div>
                        </div>
                        <h5 className="right-line color-success">Alamat KTP</h5>
                        <div className="row">
                            <div className="form-group col-md-6">
                                <label className="control-label">Kecamatan *</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-map"></i></span>
                                    <select className="form-control" value={no_kec} onChange={(e) => getKelurahan(e.target.value)} required>
                                        <option value="">==</option>
                                        {kecamatan.map((val, i) => (
                                            <option key={i} value={val.no_kec}>{i + 1 + '. ' + val.nama_kec}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <label className="control-label">Kelurahan *</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-map"></i></span>
                                    <select className="form-control" value={no_kel} onChange={(e) => setNoKel(e.target.value)} required>
                                        <option value="">==</option>
                                        {kelurahan.map((val, i) => (
                                            <option key={i} value={val.no_kel}>{i + 1 + '. ' + val.nama_kel}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <label className="control-label" htmlFor="alamat">Alamat *</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-map"></i></span>
                                    <input type="text" id="alamat" className="form-control" value={alamat} onChange={(e) => setAlamat(e.target.value)} required/>
                                </div>
                            </div>
                            <div className="form-group col-md-2">
                                <label className="control-label" htmlFor="no_rw">No. Rw *</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-map"></i></span>
                                    <input type="text" id="no_rw" className="form-control" value={no_rw} onChange={(e) => setNoRw(e.target.value)} required/>
                                </div>
                            </div>
                            <div className="form-group col-md-2">
                                <label className="control-label" htmlFor="no_rt">No. Rt *</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-map"></i></span>
                                    <input type="text" id="no_rt" className="form-control" value={no_rt} onChange={(e) => setNoRt(e.target.value)} required/>
                                </div>
                            </div>
                            <div className="form-group col-md-2">
                                <label className="control-label" htmlFor="kd_pos">Kode Pos *</label>
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-map"></i></span>
                                    <input type="text" id="kd_pos" className="form-control" value={kd_pos} onChange={(e) => setKdPos(e.target.value)} required/>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-raised btn-success br-2 no-m" type="Submit"><i className="fa fa-edit"></i> Update</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div className={pesan ? "modal-open" : ""}>
            <div style={display} className={pesan ? "modal modal-primary show" : "modal modal-primary"} id="myData" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog center">
                    <div className="modal-content modal-sm">
                        <div className="modal-header header-modal-primary p-1">
                            <h4 className="modal-title text-center no-p font-bold" id="myModalLabel">
                                PESAN
                            </h4>
                        </div>
                        <div className="modal-body text-center">
                            <h4 className="font-bold">{msg.toUpperCase()}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {pesan ? <div className="modal-backdrop fade in"></div> : ""}
    </>)
}